var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoAcademyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_36146",
    "data-name": "Gruppe 36146",
    transform: "translate(-702.83 -3690.77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(702.83 3690.77)",
    fill: "#e5f5f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-video",
    "data-name": "Icon awesome-video",
    d: "M12.841,4.5H1.826A1.826,1.826,0,0,0,0,6.326V17.341a1.826,1.826,0,0,0,1.826,1.826H12.841a1.826,1.826,0,0,0,1.826-1.826V6.326A1.826,1.826,0,0,0,12.841,4.5Zm7.234,1.44L15.889,8.827v6.012l4.186,2.884A1.225,1.225,0,0,0,22,16.737V6.925A1.225,1.225,0,0,0,20.075,5.94Z",
    transform: "translate(713.83 3701.27)",
    fill: "#1c9d87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoAcademyIcon);
export default __webpack_public_path__ + "static/media/VideoAcademyIcon.4e206460b98810b5b20ddd300609e315.svg";
export { ForwardRef as ReactComponent };